import React, { useState, useEffect } from "react";
import axios from "axios";
import "./MyStats.css";

const API_HOST = process.env.REACT_APP_API_URL;

const MyStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchMyStats();
  }, []);

  const fetchMyStats = async () => {
    const authToken = sessionStorage.getItem("authToken");
    try {
      const response = await axios.get(`${API_HOST}blogs/stats/my-stats`, {
        headers: { "auth-token": authToken },
      });
      setStats(response.data);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching my stats:", err);
      setError("Failed to load your statistics");
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="my-stats-loading">Loading your statistics...</div>;
  }

  if (error) {
    return <div className="my-stats-error">{error}</div>;
  }

  if (!stats) {
    return null;
  }

  const publicPercentage = stats.total > 0 ? ((stats.publicCount / stats.total) * 100).toFixed(1) : 0;
  const privatePercentage = stats.total > 0 ? ((stats.privateCount / stats.total) * 100).toFixed(1) : 0;

  return (
    <div className="my-stats-container">
      <h2>📊 Your Blog Statistics</h2>
      <p className="author-name">Author: <strong>{stats.creator}</strong></p>

      <div className="my-stats-grid">
        <div className="my-stat-card total">
          <div className="stat-icon">📚</div>
          <div className="stat-info">
            <div className="stat-value">{stats.total}</div>
            <div className="stat-label">Total Blogs</div>
          </div>
        </div>

        <div className="my-stat-card recent">
          <div className="stat-icon">📅</div>
          <div className="stat-info">
            <div className="stat-value">{stats.last7Days}</div>
            <div className="stat-label">Last 7 Days</div>
          </div>
        </div>

        <div className="my-stat-card month">
          <div className="stat-icon">📆</div>
          <div className="stat-info">
            <div className="stat-value">{stats.last30Days}</div>
            <div className="stat-label">Last 30 Days</div>
          </div>
        </div>
      </div>

      <div className="visibility-stats">
        <h3>Publication Status</h3>
        <div className="visibility-cards">
          <div className="visibility-card public">
            <div className="visibility-icon">✅</div>
            <div className="visibility-info">
              <div className="visibility-count">{stats.publicCount}</div>
              <div className="visibility-label">Public ({publicPercentage}%)</div>
              <div className="visibility-bar" style={{ width: `${publicPercentage}%` }}></div>
            </div>
          </div>

          <div className="visibility-card private">
            <div className="visibility-icon">🔒</div>
            <div className="visibility-info">
              <div className="visibility-count">{stats.privateCount}</div>
              <div className="visibility-label">Private ({privatePercentage}%)</div>
              <div className="visibility-bar" style={{ width: `${privatePercentage}%` }}></div>
            </div>
          </div>
        </div>
      </div>

      {stats.total === 0 && (
        <div className="empty-state">
          <p>📝 You haven't written any blogs yet. Start creating!</p>
        </div>
      )}

      <button onClick={fetchMyStats} className="refresh-stats-btn">
        🔄 Refresh
      </button>
    </div>
  );
};

export default MyStats;
